<template>
  <div class="maincontent">
    <Header :title="title" :show="true" />
    <van-tabs
      @click="onClick"
      title-inactive-color="var(--hidColor)"
      title-active-color="var(--depYelColor)"
      color="var(--depYelColor)"
    >
      <van-tab  title="中国石化"></van-tab>
      <van-tab  title="中国石油"></van-tab>
      <van-field
        v-model="cardNumber"
        type="text"
        label="加油卡号"
        :placeholder="remark"
        @input="countLength($event)"
        :maxlength="mlength"
        oncopy="return false"
        onpaste="return false"
        ref="cardno"
      />
      <van-field
        v-model="confirm"
        type="text"
        label="确认卡号"
        placeholder="确认卡号"
        :maxlength="mlength"
        @input="countLength($event)"
        oncopy="return false"
        onpaste="return false"
        ref="confirmno"
      />
      <van-field v-model="userName" label="持卡人" placeholder="持卡人" ref="owner"/>
      <van-field v-model="phone" type="number" maxlength="11" label="手机号码" placeholder="接收通知手机号码"  ref="phone"/>
      <KBtn @click="postAdd" size="normal" title="添加" />
    </van-tabs>
    <!-- <Tips class="pageFooterPage">
      <ul>
        <li>本平台加油卡充值仅支持中石化、中石油卡充值</li>
        <li>充值开放时间为法定工作日8:30～17:30，预计到账时间为提交订单后3个工作日内</li>
        <li>
          客服热线：
          <a href="tel:400-8812-336">400-8812-336(8:30 ~ 17:30)</a>
        </li>
      </ul>
    </Tips>-->
  </div>
</template>
<script>
import {  addUpdateOilCard } from "api/submit";
/*global $ */
export default {
  components: {},
  data() {
    return {
      remark: "100011开头非副卡",
      classId: 1,
      mlength: 27,
      cardNumber: "",
      confirm: "",
      userName: "",
      phone: null,
      showAlert: false,
      cardNumberConfirm: "",
      show: false,
      show2: false,
      title: "添加油卡",
    };
  },
  mounted() {
     
  },
  methods: {
    countLength(e) {
      if (e.keyCode != 8) {
        if (this.cardNumber != "") {
          this.cardNumber = this.cardNumber.replace(/(\d{4})(?=\d)/g, "$1  ");
        }
        if (this.confirm != "") {
          this.confirm = this.confirm.replace(/(\d{4})(?=\d)/g, "$1  ");
        }
      }
    },
    postAdd() {
      
      let carvalue;
      let carvalueconfim;
      if (this.cardNumber != "" && this.cardNumber != null) {
        carvalue = this.cardNumber.replace(new RegExp(/( )/g), "");         
        if (this.classId == 1) {
          let str = carvalue.substring(0, 6);
          if (!"100011".includes(str)) {
            this.$error("请输入100011开头非副卡号");
            
            return;
          }
        } else {
          let str = carvalue.substring(0, 4);
          if ("9030900090889020".includes(str)) {
            if ("9088".includes(str)) {
              this.mlength = 22;
            }
          } else {
            this.$error("请输入9030、9000、9088、9020开头、非副卡号");
            this.$refs.cardno.focus();
            return;
          }
        }
      } else {
        this.$error("请输入" + this.remark);
        this.$refs.cardno.focus();
        return;
      }
      if (this.classId == 1) {
        if (carvalue.length != 19) {
          this.$error("请输入19位加油卡号");
          this.$refs.cardno.focus();
          return;
        }
      } else {
        if (carvalue.length != 16) {
          this.$error("请输入16位加油卡号");
          this.$refs.cardno.focus();
          return;
        }
      }

      if (this.confirm != "" && this.confirm != null) {
        carvalueconfim = this.confirm.replace(new RegExp(/( )/g), "");
        if (carvalueconfim != carvalue) {
          this.$error("两次卡号输入不一致");
          return;
        }
      } else {
        this.$error("请输入确认卡号");
        this.$refs.confirmno.focus();
        return;
      }

      if (this.userName != null && this.userName != "") {
        if (!this.$regSymbol(this.userName)) {
          this.$error("持卡人姓名仅支持中文");
          this.$refs.owner.focus();
          return;
        }
        if (this.userName.length <= 1) {
          this.$error("请输入正确的持卡人");
          this.$refs.owner.focus();
          return;
        }
      } else {
        this.$error("请输入持卡人");
        this.$refs.owner.focus();
        return;
      }
      if (!this.$regPhone(this.phone)) {
        this.$error("请输入正确的手机号码");
        this.$refs.phone.focus();
        return;
      }

      let that = this;
      that.$dialog
        .confirm({
          title: "提示",
          message:
            "<span style='color: red;font-size: 20px;font-weight:900;'>卡号：" +
            carvalue.replace(/(.{4})/g, "$1 ") +
            "</span><p>请核对卡号信息是否正确，若核对无误，再确认添加!</p>",
          confirmButtonColor: "var(--depYelColor)",
        })
        .then(() => {
          // on confirm
          that.addUpdateOilCard("",this.classId,carvalue, this.userName, this.phone);
        })
        .catch(() => {
          // on cancel
        });
    },

    onClick(name) {
      this.cardNumber = "";
      this.confirm = "";
      if (name == 0) {
        this.mlength = 27;
        this.classId = 1;
        this.remark = "100011开头非副卡";
      } else {
        this.mlength = 22;
        this.classId = 2;
        this.remark = "9030、9000、9088、9020开头、非副卡";
      }
    },
    addUpdateOilCard(id,type,carvalue,userName,phone) {
      addUpdateOilCard(id,carvalue,type-1,userName,phone).then((res) => {
        if (res.status == 200) {
          this.$successSync("添加成功", () => {
            this.$back(-1);
          });
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.maincontent {
  .van-tabs {
    // padding-top: 14px !important;
    background-color: #fff;
    border-radius: 5px;
    // box-shadow: #ccc 0 0px 1px;
    .van-tabs__content {
      button {
        width: 92%;
        margin: 14px;
      }
      input {
        width: 85px;
      }
      .van-cell {
        line-height: 40px;
      }
    }
  }
}
</style>